import { IntegrationStateProvider } from "../context/IntegrationStateContext";
import { IntegrationPanel } from "./IntegrationPanel";

interface IntegrationPanelWrapperProps {
  consumerId: string;
}

export function IntegrationPanelWrapper({
  consumerId,
}: IntegrationPanelWrapperProps) {
  return (
    <IntegrationStateProvider consumerId={consumerId}>
      <IntegrationPanel consumerId={consumerId} />
    </IntegrationStateProvider>
  );
}
